// src/whatsappConfig.js

import logo from "./assets/logo_wa.png";

export const whatsappConfig = {
    phoneNumber: "+91 9400331063",
    accountName: "Uyirmozhy",
    avatar: logo,
    allowEsc: true,
    allowClickAway: true,
    notification: true,
};
